import React from 'react';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Typography } from '@mui/material';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { SimpleModal, BackdropLoader } from '@livable/saas-react-components';
export const AbsorbAdjustmentsModal = observer(_ref => {
  let isOpenExternal = _ref.isOpenExternal,
    handleModalCloseExt = _ref.handleModalCloseExt,
    handleSubmit = _ref.handleSubmit;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles();
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    noPadding: true,
    trigger: null,
    isOpen: isOpenExternal,
    title: 'Absorb adjustments',
    handleClose: handleModalCloseExt
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.allocations.postExcludeCorrectionAsync.inProgress || store.allocations.postIncludeCorrectionAsync.inProgress
  }), /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t("If adjustments are absorbed by owner, under-billed residents won't be charged extra, and the excess amount will be absorbed by the owner. Similarly, over-billed residents won't receive extra credit.")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('Do you want the owner to absorb adjustments?'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandart
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalCloseExt
  }, "Cancel")), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    onClick: async () => {
      await handleSubmit();
    }
  }, "Absorb adjustments"))))));
});